import React, { useEffect, useState } from "react";
import Header from "../../../Common/Header";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLawyerLeadList } from "../../../Redux/Slices/LawyerSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as BsIcons from 'react-icons/bs';


function LawyerLeadList() {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const data = useSelector((state) => state.Lawyer.lawyerLeadList);
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();

  const redirectToBuyerSellerDetails = (id) => {
    //  alert(id)
    navigate(`/BuyerSideDetials/${id}`);
  };
  console.log("data in Lawyer :", data);

  useEffect(() => {
    const userData = {
      headers: {
        authorization: token,
      },
    };

    dispatch(getLawyerLeadList({ id: userId, data: userData }));
  }, [userId, token]);

  const acceptLead = (leadId) => {
    const data = {
      method: "PUT",
      headers: {
        authorization: token,
      },
    };



    fetch(`https://propertysearch.ai/api/lawyer/accpetlead/${leadId}`, data)
      .then((response) => response.json())
      .then((data) => {
        console.log("accept leaad", data);
        if (data.status == true) {
          toast.success("Lead accepted successfully");
          const userData = {
            headers: {
              authorization: token,
            },
          };
          dispatch(getLawyerLeadList({ id: userId, data: userData }));
        }
      })
      .catch((err) => console.log(err));
  };


  return (
    <div className="wrapper dashboard-wrapper">
      <div className="d-flex flex-wrap flex-xl-nowrap">
        <div className="page-content">
          {/* <Header /> */}
          <main id="content " className="bg-gray-01">
            <ToastContainer />
            <div className="px-3 px-lg-6 px-xxl-13 py-5 py-lg-10">
              <div className="d-flex flex-wrap flex-md-nowrap mb-6">
                <div className="mr-0 mr-md-auto">
                  <h2 className="mb-0 text-heading fs-22 lh-15 mt-5 mt-lg-0">
                    Leads List
                    {/* <span className="badge badge-white badge-pill text-primary fs-18 font-weight-bold ml-2">
                      2
                    </span> */}
                  </h2>
                  {/* mbkhole1@gmail.com */}
                </div>
                
              </div>
              <div className="table-responsive">
                <table className="table table-hover bg-white border rounded-lg">
                  <thead className="thead-sm thead-black">
                    <tr>
                      <th scope="col" className="border-top-0 px-6 pt-5 pb-4">
                        Lead List
                      </th>
                      <th scope="col" className="border-top-0 px-6 pt-5 pb-4">
                        Property Name
                      </th>
                      {/* <th scope="col" className="border-top-0 pt-5 pb-4">
                        Contact Number
                      </th> */}
                      <th scope="col" className="border-top-0 pt-5 pb-4">
                        Action
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item, index) => {
                      return (
                        <tr
                          className="shadow-hover-xs-2 bg-hover-white"
                          key={index}
                          
                        >
                          <td
                            
                            className="align-middle  px-6"
                          >
                            <div className="media">
                              <div className="w-120px mr-4 position-relative">
                                <a>
                                  <img src="images/agent-12.jpg" alt="" />
                                </a>
                              </div>
                              <div className="media-body">
                                <a href="#" className="text-dark hover-primary">
                                  <h5 className="fs-16 mb-0 lh-18">
                                    {item?.buyerdata?.firstname}{" "}{item?.buyerdata?.lastname}
                                  </h5>
                                </a>
                                <p className="mb-1 font-weight-500">
                                  Kharadi, Pune
                                </p>
                              </div>
                            </div>
                          </td>
                          <td className="align-middle">
                            {item?.propertydata?.title}
                          </td>
                          {/* <td className="align-middle">
                            {item?.buyerdata?.phoneNumber}
                          </td> */}

                          <td className="align-middle">
                            {item?.lawyerdata?.requeststatus == true ?   
                               <button
                               type="button"
                               className="btn btn-primary px-5 mr-3"
                               onClick={()=>redirectToBuyerSellerDetails(item?.lawyerdata?.id)}
                             >
                               View Detail
                             </button>

                             :

                            <button
                              type="button"
                              className="btn btn-primary px-5"
                              onClick={() => acceptLead(item?.lawyerdata?.id)}
                            >
                              Accept
                            </button>
                            }
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <nav className="mt-6">
                <ul className="pagination rounded-active justify-content-center">
                  <li className="page-item">
                    <a className="page-link" href="#">
                      <i className="far fa-angle-double-left"></i>
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      1
                    </a>
                  </li>
                  <li className="page-item active">
                    <a className="page-link" href="#">
                      2
                    </a>
                  </li>
                  <li className="page-item d-none d-sm-block">
                    <a className="page-link" href="#">
                      3
                    </a>
                  </li>
                  <li className="page-item">...</li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      6
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      <i className="far fa-angle-double-right"></i>
                    </a>
                  </li>
                </ul>
              </nav>
              <div className="text-center mt-2">6-10 of 29 Results</div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default LawyerLeadList;
